import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top on route change
 * This ensures that when navigating to a new page, the scroll position is reset to top
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page on route change
    window.scrollTo(0, 0);
  }, [pathname]); // Effect runs when pathname changes

  return null; // This component doesn't render anything
};

export default ScrollToTop;